const FieldControls = {
  init(target) {
    const input = target.querySelector('input') as HTMLInputElement
    const textarea = target.querySelector('textarea') as HTMLTextAreaElement
    let el: HTMLInputElement | HTMLTextAreaElement | null = null

    if (input) {
      el = input
    }
    if (textarea) {
      el = textarea
    }

    el = input || textarea || null

    if (el !== null) {
      el.addEventListener('blur', () => this.onBlur(el))
      el.addEventListener('focus', () => this.onFocus(el))
    }
  },
  onBlur(el) {
    el.classList.add('input--changed')
  },
  onFocus(el) {
    el.classList.remove('input--changed')
  },
}

export default FieldControls
